// Подпись о ценах календаря (T14). Число ночей берётся из набора ценовых длин сервера
// (/api/config.priceLengths — обнаруживает сканер, T13), а не зашито: при смене тарифов подпись
// меняется сама. minStay в конфиге — фактический минимальный заезд, который сканер находит по
// тарифам Шелтера (T28; кратчайшая длина набора), поэтому и плашка «Бронирование от N ночей»
// следует за тарифами. Набор из одной длины — фразы «от N ночей» нет: цена в ячейке и есть цена
// минимального заезда. Чистая функция — под юнит-тесты.

// «от N ночей» — родительный падеж: 1/21/31 → «ночи», остальное → «ночей» (11 — исключение)
export function fromNights(n) {
  const one = n % 10 === 1 && n % 100 !== 11;
  return `от ${n} ${one ? "ночи" : "ночей"}`;
}

export function priceNote(config) {
  if (!config) return null;
  const minStay = Number(config.minStay) || 1;
  const lengths = Array.isArray(config.priceLengths)
    ? config.priceLengths.map(Number).filter(Number.isInteger)
    : [];
  const longStay = Math.max(minStay, ...lengths);
  const longer = longStay > minStay;
  return {
    minStay,
    longStay,
    lead: "В календаре указана минимальная цена за ночь",
    detail: longer ? `при бронировании ${fromNights(longStay)}` : null,
    tail: longer ? "Для более короткого заезда точную стоимость покажем после выбора дат." : null,
    pill: `Бронирование ${fromNights(minStay)}`,
    legendSuffix: longer ? ` (${fromNights(longStay)})` : "",
  };
}
